// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"1063e5dd","296":"845a69ba","361":"b74178f1","453":"57c3e370","537":"2eb33af3"}[chunkId] + ".chunk.js";
};